import { useLang } from "../../i18n/LangContext";
import { DynIcon } from "../../lib/icons";
import { SectionHead } from "./Brand";

export const HowItWorks = () => {
  const { how: t } = useLang().t;
  return (
  <section id="how" className="relative border-y border-[#D4AF37]/15 bg-[#0E0F14] py-24">
    <div className="streak" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHead eyebrow={t.eyebrow} title={t.title} />
      <div className="grid gap-6 md:grid-cols-3">
        {t.steps.map((s, i) => (
          <div key={s.title} className="glass-card relative p-8" data-testid={`how-it-works-step-${i + 1}`}>
            <div className="flex items-start justify-between">
              <span className="font-serif text-6xl font-bold text-[#D4AF37]/20">0{i + 1}</span>
              {s.icon && <span className="fx-icon grid h-11 w-11 place-items-center rounded-full border border-[#D4AF37]/50 text-[#D4AF37]"><DynIcon name={s.icon} size={18} /></span>}
            </div>
            <h3 className="mt-4 font-serif text-xl font-semibold text-[#D4AF37]">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="mt-20 grid grid-cols-2 gap-8 md:grid-cols-4">
        {t.stats.map((s, i) => (
          <div key={s.label} data-testid={`stat-${i}`} className="border-l border-[#D4AF37]/40 pl-5">
            <p className="font-serif text-3xl font-bold gold-text sm:text-4xl">{s.value}</p>
            <p className="mt-1 text-xs uppercase tracking-widest text-zinc-500">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
  );
};
